<button 
  [type]="type" 
  class="cursor-pointer"
  [ngClass]="{'btn-default':isDefault,'noDefault':!isDefault}"
  [class.adjusted-padding]="useLowPadding"
  [class.correct]="state === 'correct'" 
  [class.incorrect]="state === 'incorrect'"
  [disabled]="disabled" 
  [ngStyle]="customStyle"
  (click)="handleClick($event)">
  {{ text }}
</button>

